import * as bookingOpenDatesApi from '@/api/bookingOpenDates/bookingOpenDates'

const bookingOpenDates = {
  state: {
  },
  mutations: {
  },
  actions: {
    getBookingOpenDates ({ commit }, data) {
      return new Promise((resolve, reject) => {
        bookingOpenDatesApi.getBookingOpenDates(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },

  }
}

export default bookingOpenDates
